import React from "react";

import { zeroPaddingText } from "../../libs/Util";
import SideModal from "../../atoms/SideModal";
import { ReactComponent as IncompleteMark } from "../../assets/svg/check-mark.svg";
import { ReactComponent as CompleteMark } from "../../assets/svg/check-circle.svg";
import { VideoChapterWork } from "../../state";

import styles from "./SelectAnswersModal.module.scss";

interface Props {
  parentPositionTop: string;
  parentPositionLeft: string;
  lessonName: string;
  lessonTitle: string;
  teachingMaterialName: string;
  works: VideoChapterWork[];
  retrospectiveWorkTitle?: string;
  handleClose: () => void;
  handleClickWork: (workId: number) => void;
}

const SelectAnswersModal = ({
  parentPositionTop,
  parentPositionLeft,
  lessonName,
  lessonTitle,
  teachingMaterialName,
  works,
  retrospectiveWorkTitle,
  handleClose,
  handleClickWork,
}: Props) => {
  return (
    <SideModal
      onClose={handleClose}
      parentPositionTop={parentPositionTop}
      parentPositionLeft={parentPositionLeft}
    >
      <div className={styles.titleContainer}>
        <p className={styles.name}>
          {teachingMaterialName} {lessonName}
        </p>
        <p className={styles.title}>{lessonTitle}</p>
      </div>
      <hr />
      <div className={styles.contentContainer}>
        {works.map(work => (
          <div key={work.id} className={styles.content}>
            {work.is_completed ? <CompleteMark /> : <IncompleteMark />}
            <p onClick={() => handleClickWork(work.id)}>
              {work.title === retrospectiveWorkTitle
                ? "振り返り"
                : zeroPaddingText(work.title).replace("ワーク", "WORK")}
            </p>
          </div>
        ))}
      </div>
    </SideModal>
  );
};

export default SelectAnswersModal;
